import React from 'react';
import PropTypes from 'prop-types';
import { H6 } from '@contently/toolkit';
import { useResource } from 'rest-hooks';
import ContentResource from '../../resources/ContentResource';
import TextEditor from './TextEditor';

export default function BodyTextEditor({ storyId, historyMode, readOnlyMode }) {
  const storyContents = useResource(ContentResource.listShape(), { contentable_id: storyId });
  const body = storyContents.find(c => c.format === 'rich');

  return (
    <React.Fragment>
      <H6>Body</H6>
      {body && (
        <TextEditor
          contentEditorId={body.uuid}
          contentId={parseInt(body.id, 10)}
          historyMode={historyMode}
          readOnlyMode={readOnlyMode}
          format="rich"
        />
      )}
    </React.Fragment>
  );
}

BodyTextEditor.defaultProps = {
  historyMode: false,
  readOnlyMode: false
};

BodyTextEditor.propTypes = {
  storyId: PropTypes.number.isRequired,
  historyMode: PropTypes.bool,
  readOnlyMode: PropTypes.bool
};



// WEBPACK FOOTER //
// ./app/javascript/client/components/textEditor/BodyTextEditor.jsx